export const API_ROOT = 'https://shareapi.sam-performance.com/api';